import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ContextProviderAttachedStore } from './types'

export const BuilderContextProvidersAttachedStore = withDependencies(
	[],
	(): ContextProviderAttachedStore => {
		const subscribers: { [compId: string]: () => void } = {}
		return {
			notifyChanges(compId: string): void {
				subscribers[compId]?.()
			},
			subscribeToChanges(compId: string, callback: () => void): () => void {
				subscribers[compId] = callback
				return () => {
					delete subscribers[compId]
				}
			}

		}
	}
)
